var map = {
	"./basic_name.svg": 15,
	"./io_name.svg": 17,
	"./simquadrat_name.svg": 18,
	"./sipgate_name.svg": 20,
	"./team_name.svg": 22,
	"./trunking_name.svg": 24
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns ^\.\/.*_name\.svg$
// module id = 264
// module chunks = 0